import { Component, OnInit } from '@angular/core';
import { MarketplaceService } from '@fgb/core';
import { zip } from 'rxjs';

@Component({
  selector: 'fgb-rewards-page',
  templateUrl: './rewards-page.component.html',
  styleUrls: ['./rewards-page.component.scss'],
})
export class RewardsPageComponent implements OnInit {
  constructor(private marketplaceService: MarketplaceService) {}
  showOffCanvas: boolean = false;

  ngOnInit() {
    zip(this.marketplaceService.fetchMarketplaceItems()).toPromise();
  }
}
